import z from 'zod';

import { StringKey } from '../lang/index';

const MAX_FILE_SIZE = 1024 * 1024 * 10;
const ACCEPTED_FILE_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv',
  'image/png',
  'image/jpeg',
];

export const LOGO_FILE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml'];

export enum Order {
  ASC = 'asc',
  DESC = 'desc',
}

export enum StatusFilter {
  ACTIVE = 'filter-active',
  ALL = 'filter-all',
  INACTIVE = 'filter-inactive',
}

export const statusFilterTranslationKey: Record<StatusFilter, StringKey> = {
  [StatusFilter.ALL]: 'ALL',
  [StatusFilter.ACTIVE]: 'ACTIVE',
  [StatusFilter.INACTIVE]: 'INACTIVE',
};

export const statusFilterMap = Object.keys(statusFilterTranslationKey);

export const zodFileSchema = ({
  fileMimeTypes = ACCEPTED_FILE_MIME_TYPES,
  maxFileSize = MAX_FILE_SIZE,
}: {
  fileMimeTypes?: string[];
  maxFileSize?: number;
} = {}) =>
  z.object({
    docLink: z.string(),
    loadProgress: z.number().max(100),
    abort: z.function(),
    id: z.string(),
    doc: z
      .custom<File>()
      .or(
        z.object({
          size: z.number(),
          type: z.string(),
          name: z.string(),
        }),
      )
      .refine(({ type }) => fileMimeTypes.includes(type), 'File format is not supported')
      .refine(({ size }) => size <= maxFileSize, 'File size is too large'),
  });
